import type { MultiPackageBatchStatus, MultiPackagePrintResultItem } from '../../types/multiPackagePrint';

// RecoveryRequired is durable until output delivery is confirmed. An error-free
// OutputPending item is a successful browser handoff, not a failed operation.
// Earlier stages can be interrupted without an error receipt: keep recovery there.
export function isAwaitingMultiPackageOutput(item: MultiPackagePrintResultItem): boolean {
  return item.status === 'RecoveryRequired' && item.stage === 'OutputPending'
    && !item.errorCode?.trim() && !item.errorMessage?.trim();
}

export function multiPackageItemStatusLabel(
  item: MultiPackagePrintResultItem,
  isPreparingOutput = false,
): string {
  if (isAwaitingMultiPackageOutput(item)) {
    return isPreparingOutput ? 'Preparing output' : 'Ready to download';
  }
  return item.status === 'RecoveryRequired' ? 'Recovery required' : item.status;
}

export function multiPackageBatchStatusLabel(
  status: MultiPackageBatchStatus,
  items: MultiPackagePrintResultItem[],
  isPreparingOutput = false,
): string {
  const incomplete = items.filter((item) => item.status !== 'Completed');
  if (status === 'RecoveryRequired' && incomplete.length > 0
    && incomplete.every(isAwaitingMultiPackageOutput)) {
    return isPreparingOutput ? 'Preparing output' : 'Ready to download';
  }
  return status === 'RecoveryRequired' ? 'Recovery required' : status;
}
